import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { AvThemeToggleComponent } from '../theme-toggle/theme-toggle.component';
import { OperatorFacade } from '../../../../Facades/operator.facade';
import { NavItem } from '../../Interfaces/nav-item.interface';
import { NAV_ITEMS } from '../../../../Consts/navigation.const';

@Component({
  selector: 'av-sidenav',
  standalone: true,
  imports: [RouterLink, MatIconModule, AvThemeToggleComponent, TranslatePipe],
  templateUrl: './av-sidenav.component.html',
  styleUrl: './av-sidenav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-flex flex-column h-100' },
})
export class AvSidenavComponent {
  private readonly _router = inject(Router);
  private readonly _operatorFacade = inject(OperatorFacade);

  private readonly _currentUrl = toSignal(
    this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
      startWith(this._router.url),
    ),
  );

  readonly navItems = computed<NavItem[]>(() =>
    NAV_ITEMS.filter((item) => this._operatorFacade.atLeast(item.minRole)),
  );

  readonly activeRoute = computed<string>(() => {
    const url = this._currentUrl() ?? this._router.url;

    return '/' + (url.split('/')[1]?.split('?')[0] ?? '');
  });
}
